  (function () {
    "use strict";

    function initializeBenchCalculator() {
    var root = document.getElementById("toBenchCalc");
    if (!root || root.dataset.initialized === "true") {
      return;
    }
    root.dataset.initialized = "true";

    var result = document.getElementById("toBenchResult");
    var outputGrid = document.getElementById("toBenchOutputGrid");
    var tableWrap = document.getElementById("toBenchTableWrap");
    var tableBody = document.getElementById("toBenchTableBody");
    var outOneRm = document.getElementById("toOutOneRm");
    var outWorkWeight = document.getElementById("toOutWorkWeight");
    var outAccuracy = document.getElementById("toOutAccuracy");

    function numberValue(id) {
      return Number(String(document.getElementById(id).value).replace(",", "."));
    }

    function roundToPlate(weight) {
      return Math.round(weight / 2.5) * 2.5;
    }

    function formatKg(weight) {
      return weight.toLocaleString("fi-FI", {
        minimumFractionDigits: weight % 1 ? 1 : 0,
        maximumFractionDigits: 1
      }) + " kg";
    }

    function estimatedOneRm(weight, reps) {
      return reps === 1 ? weight : weight * (1 + reps / 30);
    }

    function estimatedSetWeight(oneRm, reps) {
      return reps === 1 ? oneRm : oneRm / (1 + reps / 30);
    }

    function accuracyFor(reps) {
      if (reps <= 5) return "Hyvä";
      if (reps <= 10) return "Kohtalainen";
      return "Suuntaa antava";
    }

    function showMessage(message) {
      result.querySelector("p").textContent = message;
    }

    function hideOutputs() {
      outputGrid.hidden = true;
      tableWrap.hidden = true;
    }

    function setActivePill(containerSelector, activeButton) {
      root.querySelectorAll(containerSelector + " button").forEach(function (button) {
        button.classList.toggle("active", button === activeButton);
      });
    }

    root.querySelectorAll(".to-tab").forEach(function (tab) {
      tab.addEventListener("click", function () {
        var mode = tab.dataset.mode;
        root.querySelectorAll(".to-tab").forEach(function (button) {
          button.classList.toggle("active", button === tab);
        });
        root.querySelectorAll(".to-mode-panel").forEach(function (panel) {
          panel.classList.toggle("hidden", panel.dataset.panel !== mode);
        });
        hideOutputs();
        showMessage("Syötä laskentaan tarvittavat tiedot.");
      });
    });

    root.querySelectorAll(".to-rep-buttons button").forEach(function (button) {
      button.addEventListener("click", function () {
        document.getElementById("toBenchReps").value = button.dataset.reps;
        setActivePill(".to-rep-buttons", button);
      });
    });

    root.querySelectorAll(".to-target-rep-buttons button").forEach(function (button) {
      button.addEventListener("click", function () {
        document.getElementById("toTargetReps").value = button.dataset.targetReps;
        setActivePill(".to-target-rep-buttons", button);
      });
    });

    document.getElementById("toCalcBenchMax").addEventListener("click", function () {
      var weight = numberValue("toBenchWeight");
      var reps = numberValue("toBenchReps");
      if (!(weight > 0) || !(reps >= 1 && reps <= 30)) {
        hideOutputs();
        showMessage("Syötä paino ja toistomäärä väliltä 1-30.");
        return;
      }

      var oneRm = roundToPlate(estimatedOneRm(weight, reps));
      outOneRm.textContent = formatKg(oneRm);
      outWorkWeight.textContent = formatKg(roundToPlate(oneRm * 0.8));
      outAccuracy.textContent = accuracyFor(reps);
      outputGrid.hidden = false;
      tableWrap.hidden = true;
      showMessage("Arvioitu yhden toiston maksimisi on " + formatKg(oneRm) + ".");
    });

    document.getElementById("toCalcSetWeight").addEventListener("click", function () {
      var oneRm = numberValue("toBenchOneRm");
      var reps = numberValue("toTargetReps");
      if (!(oneRm > 0) || !(reps >= 1 && reps <= 30)) {
        hideOutputs();
        showMessage("Syötä maksimisi ja tavoitetoistot väliltä 1-30.");
        return;
      }

      var setWeight = roundToPlate(estimatedSetWeight(oneRm, reps));
      outputGrid.hidden = true;
      tableWrap.hidden = true;
      showMessage("Arvioitu sarjapaino " + reps + " toistolle on " + formatKg(setWeight) + ".");
    });

    document.getElementById("toCalcBenchTable").addEventListener("click", function () {
      var oneRm = numberValue("toBenchTableMax");
      if (!(oneRm > 0)) {
        hideOutputs();
        showMessage("Syötä arvioitu yhden toiston maksimisi.");
        return;
      }

      var purposes = {
        1: "Maksimivoiman arvio",
        3: "Raskas voimaharjoittelu",
        5: "Voimaharjoittelu",
        6: "Voima ja lihaskasvu",
        8: "Lihaskasvu",
        10: "Lihaskasvu",
        12: "Volyymi ja lihaskasvu",
        15: "Kevyt volyymi",
        20: "Tekniikka ja kestävyys"
      };

      tableBody.innerHTML = "";
      Object.keys(purposes).forEach(function (reps) {
        var row = document.createElement("tr");
        var cells = [
          reps,
          formatKg(roundToPlate(estimatedSetWeight(oneRm, Number(reps)))),
          purposes[reps]
        ];
        cells.forEach(function (text) {
          var cell = document.createElement("td");
          cell.textContent = text;
          row.appendChild(cell);
        });
        tableBody.appendChild(row);
      });

      outputGrid.hidden = true;
      tableWrap.hidden = false;
      showMessage("Taulukko on laskettu maksimilla " + formatKg(oneRm) + ".");
    });

    document.getElementById("toBenchReset").addEventListener("click", function () {
      root.querySelectorAll("input").forEach(function (input) {
        input.value = "";
      });
      root.querySelectorAll(".to-pills button").forEach(function (button) {
        button.classList.remove("active");
      });
      hideOutputs();
      tableBody.innerHTML = "";
      showMessage("Syötä paino ja toistomäärä tai arvioitu maksimi.");
    });
    }

    initializeBenchCalculator();

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initializeBenchCalculator);
    }

    window.addEventListener("pageshow", initializeBenchCalculator);
    document.addEventListener("shopify:section:load", initializeBenchCalculator);
  }());